import './index.less';

import { Button, Form, InputNumber, message, Modal } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/store';
import { updateSmeApplicationProcessingFeeThunk } from '../../../../services/smeApplicationService/smeApplicationThunk';
import { SME_APPLICATION_STATUS } from '../../../../enum/smeApplicationStatus';
import { SmeApplication } from '../../../../features/smeApplication/smeApplicationSlice';

type UpdateProcessingFeeModalProps = {
  applicationDetails?: SmeApplication;
  callback?: () => void;
};

const UpdateProcessingFeeModal: React.FC<UpdateProcessingFeeModalProps> = (props) => {
  const { applicationDetails, callback } = props;
  const dispatch = useDispatch<AppDispatch>();

  const [form] = Form.useForm();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setLoading(false);
    form.resetFields();
  };

  const onFinish = async () => {
    await form
      .validateFields()
      .then(async (values) => {
        setLoading(true);

        const processingFee = values.processingFee;

        await dispatch(
          updateSmeApplicationProcessingFeeThunk({
            applicationId: applicationDetails?.id || '',
            processingFee,
          })
        )
          .unwrap()
          .then(() => {
            if (callback) callback();
            message.success('Update Successfully');
          });
      })
      .catch((err) => {
        message.error('Something went wrong. Please try again later.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Button
        type="primary"
        onClick={showModal}
        disabled={
          ![SME_APPLICATION_STATUS.PENDING, SME_APPLICATION_STATUS.REFERBACK].includes(
            (applicationDetails?.status || '') as SME_APPLICATION_STATUS
          )
        }
        ghost
      >
        Update
      </Button>
      <Modal
        title="Update Processing Fee"
        okText="Confirm"
        open={isModalOpen}
        onOk={onFinish}
        onCancel={handleCancel}
        confirmLoading={loading}
        width={360}
        destroyOnClose
        centered
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          initialValues={{
            processingFee: applicationDetails?.processingFee,
          }}
        >
          <Form.Item
            name="processingFee"
            rules={[{ required: true, message: 'Processing Fee is required' }]}
          >
            <InputNumber
              placeholder="Please input"
              style={{ width: '100%' }}
              controls={false}
              inputMode="numeric"
              type={'number'}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateProcessingFeeModal;
